import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Colors } from 'modules/theme';

const DASHBOARD_URL = 'https://app.yieldbucks.com';

const benefits = [
  'Attract new customers by offering cash-back rewards on purchases',
  'Keep existing customers coming back with loyalty incentives',
  'No upfront cost — only pay when customers redeem rewards',
  'Manage your offers and track performance from a simple dashboard',
  'Get discovered by YieldBucks users already searching for deals near them',
];

const BusinessComponent = () => (
  <Container
    fluid
    className="py-5"
    style={{ backgroundColor: Colors.blackBackground }}
    id="for-businesses"
  >
    <Container className="py-4">
      <Row className="align-items-center">
        <Col xs={12} md={6} className="mb-5 mb-md-0">
          <h1 style={{ color: Colors.blueButton }}>Grow Your Business</h1>
          <h1 style={{ color: Colors.yellowExtra, marginBottom: 24 }}>with YieldBucks</h1>
          <p
            style={{
              color: Colors.white,
              marginBottom: 32,
              fontSize: 17,
              lineHeight: 1.7,
              fontFamily: 'Open Sans, sans-serif',
            }}
          >
            Join thousands of businesses offering rewards to YieldBucks users. Drive foot traffic,
            build loyalty, and grow revenue — all from one easy-to-use platform.
          </p>
          {benefits.map((benefit, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 14 }}>
              <span
                style={{
                  color: Colors.yellowExtra,
                  fontSize: 18,
                  fontWeight: 'bold',
                  marginRight: 12,
                  marginTop: 1,
                  flexShrink: 0,
                  fontFamily: 'Open Sans, sans-serif',
                }}
              >
                ✓
              </span>
              <span
                style={{
                  color: Colors.white,
                  fontSize: 16,
                  lineHeight: 1.6,
                  fontFamily: 'Open Sans, sans-serif',
                }}
              >
                {benefit}
              </span>
            </div>
          ))}
        </Col>

        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
          <Container
            style={{
              background: Colors.greyDark,
              borderRadius: 16,
              padding: 40,
              textAlign: 'center',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
              maxWidth: 420,
            }}
          >
            <h2 style={{ color: Colors.yellowExtra, marginBottom: 8, textAlign: 'center' }}>
              Ready to get started?
            </h2>
            <p
              style={{
                color: Colors.white,
                marginBottom: 32,
                fontSize: 15,
                lineHeight: 1.6,
                fontFamily: 'Open Sans, sans-serif',
                textAlign: 'center',
              }}
            >
              Create your free business account and start reaching YieldBucks customers today.
            </p>
            <Button
              onClick={() => window.open(`${DASHBOARD_URL}/business-signup`, '_blank')}
              style={{
                backgroundColor: Colors.yellowExtra,
                border: 'none',
                borderRadius: 8,
                width: '100%',
                height: 52,
                fontSize: 18,
                fontWeight: 'bold',
                color: Colors.blackBackground,
                marginBottom: 16,
              }}
            >
              Register Your Business
            </Button>
            <p style={{ color: Colors.whiteTextSecondary, margin: 0, fontSize: 14 }}>
              Already have an account?{' '}
              <span
                style={{ color: Colors.blueButton, cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => window.open(`${DASHBOARD_URL}/login`, '_blank')}
              >
                Sign in here
              </span>
            </p>
          </Container>
        </Col>
      </Row>
    </Container>
  </Container>
);

export default BusinessComponent;
